<script>
	import { onMount } from 'svelte';

	export let domain;
	let email;
	let success;
	let trace;

	onMount(async () => {
		const traceRequest = await fetch('https://www.cloudflare.com/cdn-cgi/trace');
		trace = await traceRequest.text();
	});

	const handleClick = (event) => {
		event.preventDefault();

		firebase.database().ref("contacts").push().set({
			domain: domain,
			email: email,
			timestamp: firebase.database.ServerValue.TIMESTAMP,
			trace: trace,
		}, (error) => {
			if (error) {
				console.error(error);
			} else {
				success = true;
			}
		});
	}
</script>

<style>
</style>

<h1>{domain} is for sale!</h1>
{#if success}
	<p>Thanks for reaching out! We'll be in touch.</p>
{:else}
	<p>Input your email address below if you'd like to purchase it and we'll be in touch.</p>
	<form>
		<input type="email" bind:value={email} placeholder="me@email.com"/>
		<button type="submit" on:click={handleClick}>I'm interested!</button>
	</form>
{/if}
